import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Error, Label } from "@progress/kendo-react-labels";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useEffect, useState } from "react";
import productsApi from "../../api/products";
import { Analytics, MarketsAnalytics, Settlement, TradeSummary } from "../../components/dashboard";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { useFetch } from "../../hooks/useApi";
import { useUserContext } from "../../hooks/useUserContext";

export const AnalyticsDashboard = () => {
  const { context: user } = useUserContext();
  const [selected, setSelected] = useState(0);
  const [commodities, setCommodities] = useState<any[]>([]);
  const [refresh, setRefresh] = useState(Date.now);
  const [selectedCommodity, setSelectedCommodity] = useState<any | null>(null);

  const { data, loading, error } = useFetch(productsApi.getCommodities);

  useEffect(() => {
    if (data?.commodities) {
      setCommodities(data.commodities.sort((a: any, b: any) => (a.name > b.name ? 1 : -1)));
    }
  }, [data]);

  const canViewTradeSummary = user.roles.isRiskTaker || user.roles.isBroker;

  return (
    <TabStrip selected={selected} onSelect={(e) => setSelected(e.selected)}>
      <TabStripTab title="System">
        <Analytics />
      </TabStripTab>

      {canViewTradeSummary && (
        <TabStripTab title="Trade Summary">
          <TradeSummary />
        </TabStripTab>
      )}

      {user.roles.isRiskTaker && (
        <TabStripTab title="Markets">
          <>
            <Tooltip anchorElement="target" position="bottom" parentTitle={true}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingBottom: "1rem",
                }}
              >
                {!loading && (
                  <>
                    <div>
                      <Label style={{ paddingRight: 5 }}>Commodity</Label>
                      <DropDownList
                        data={commodities}
                        value={selectedCommodity}
                        textField="name"
                        dataItemKey="id"
                        style={{ width: 350 }}
                        onChange={(e) => setSelectedCommodity(e.target.value)}
                      />
                    </div>
                    <div>
                      {selectedCommodity && (
                        <Button
                          size="small"
                          icon="arrow-rotate-cw"
                          themeColor="primary"
                          title="Refresh"
                          onClick={() => setRefresh(Date.now)}
                          style={{ marginLeft: 5 }}
                        />
                      )}
                    </div>
                  </>
                )}
                <LoadingIndicator loading={loading} />
              </div>
            </Tooltip>
            <Error>{error}</Error>

            <MarketsAnalytics commodity={selectedCommodity} refresh={refresh} />
          </>
        </TabStripTab>
      )}

      {user.roles.isRiskTaker && (
        <TabStripTab title="Settlements">
          <Settlement />
        </TabStripTab>
      )}
    </TabStrip>
  );
};
